import React, { useEffect, useMemo } from "react";

export default function HardData({ activePlayer }) {

    // ✅ special teams fields -> label
    const specialTeamsMap = useMemo(
        () => ({
            ls: "LS",
            pr: "PR",
            kr: "KR",
            st: "ST",
            g: "G",
            h: "H",
        }),
        []
    );

    // ✅ treat "0" or 0 as active
    const isZeroFlag = (val) => {
        if (val === 1) return true;
        if (val === "1") return true;
        // covers weird cases like "0 " etc.
        if (val != null && String(val).trim() === "1") return true;
        return false;
    };

    const specialTeam = Object.entries(specialTeamsMap)
        .filter(([key]) => isZeroFlag(activePlayer?.[key]))
        .map(([, label]) => label)
        .join(", ") || "-";

    return (
        <div id="hardData" className="row g-2 mb-2">
            <div className="col-48 fs-7">
                <div className="row g-1">
                    <div className="col-9 d-flex gap-1 align-items-center justify-content-start">
                        <div>Height:</div>
                        <div>
                            {activePlayer?.height || "-"} {activePlayer?.heightV || ""}{" "}
                            {activePlayer?.heightDate?.startsWith("0000") ? "-" : activePlayer?.heightDate || ""}
                        </div>
                    </div>

                    <div className="col-9 d-flex gap-1 align-items-center justify-content-start">
                        <div>Weight:</div>
                        <div>
                            {activePlayer?.weight || "-"} {activePlayer?.weightV || ""}{" "}
                            {activePlayer?.weightDate?.startsWith("0000") ? "-" : activePlayer?.weightDate || ""}
                        </div>
                    </div>

                    <div className="col-9 d-flex gap-1 align-items-center justify-content-start">
                        <div>Speed:</div>
                        <div>
                            {activePlayer?.speed40Fastest || "-"}{" "}
                            {activePlayer?.speed40FVerified || ""}{" "}
                            {activePlayer?.speed40FDate?.startsWith("0000") ? "-" : activePlayer?.speed40FDate || ""}
                        </div>
                    </div>

                    <div className="col-6 d-flex gap-1 align-items-center justify-content-start">
                        <div>DOB:</div>
                        <div>
                            {activePlayer?.dob?.startsWith("0000") ? "-" : activePlayer?.dob || "-"}
                        </div>
                    </div>

                    <div className="col-3 d-flex gap-1 align-items-center justify-content-start">
                        <div>Age:</div>
                        <div>
                            {activePlayer?.dob?.startsWith("0000") ? "-" : activePlayer?.age || "-"}
                        </div>
                    </div>

                    <div
                        className="col-10 text-start fw-bold border border-secondary rounded-2 p-1 ps-2 ms-auto"
                        id="view_special_teams"
                    >
                        Special Team: {specialTeam}
                    </div>
                </div>

                <div className="row g-2 mt-2">
                    <div className="col-12 fs-7 alert-danger">
                        <div className="d-flex align-items-center gap-2 justify-content-start p-2">
                            <div>CFL: </div>
                            <div className="text-start" id="view_cfl">
                                {activePlayer?.cflTeam === null || activePlayer?.cflTeam === "null"
                                    ? ""
                                    : activePlayer?.cflTeam}
                            </div>
                            <div className="" id="view_cflStatus">
                                {activePlayer?.cflStatus || ""}
                            </div>
                            <div className="col" id="view_date">
                                {activePlayer?.cflDate?.startsWith("0000") ? "-" : activePlayer?.cflDate || ""}
                            </div>
                            [{activePlayer?.cflDraftYear || "-"} {activePlayer?.cflDraftTeam || "-"} {activePlayer?.cflDraftRound || "-"}]
                        </div>
                    </div>

                    <div className="col-12 fs-7 alert-info">
                        <div className="d-flex align-items-center gap-2 justify-content-start p-2">
                            <div>NFL:</div>
                            <div id="view_cfl">
                                {activePlayer?.nflTeam === null || activePlayer?.nflTeam === "null"
                                    ? ""
                                    : activePlayer?.nflTeam}
                            </div>
                            <div className="" id="view_cflStatus">
                                {activePlayer?.nflStatus || ""}
                            </div>
                            <div className="col" id="view_date">
                                {activePlayer?.nflDate?.startsWith("0000") ? "" : activePlayer?.nflDate}
                            </div>
                            [{activePlayer?.nflDraftYear || "-"} {activePlayer?.nflDraftTeam || "-"} {activePlayer?.nflDraftRound || "-"}]
                        </div>
                    </div>

                    <div className="col-12 fs-7 alert-warning">
                        <div className="d-flex align-items-center gap-2 justify-content-start p-2">
                            <div>UFL24: </div>
                            <div className="text-start" id="view_cfl">
                                {activePlayer?.ufl24Team === null || activePlayer?.ufl24Team === "null"
                                    ? ""
                                    : activePlayer?.ufl24Team}
                            </div>
                            <div className="" id="view_cflStatus">
                                {activePlayer?.ufl24Status || ""}
                            </div>
                            <div className="col" id="view_date">
                                {activePlayer?.ufl24Date?.startsWith("0000") ? "" : activePlayer?.ufl24Date}
                            </div>
                            [{activePlayer?.ufl24DraftYear || "-"} {activePlayer?.ufl24DraftTeam || "-"} {activePlayer?.ufl24DraftRound || "-"}]
                        </div>
                    </div>

                    <div className="col-12 fs-7 alert-purple">
                        <div className="d-flex align-items-center gap-2 justify-content-start p-2">
                            <div>Event:</div>
                            <div className="col-20text-start ps-2" id="view_event">
                                {activePlayer?.theEvent === null || activePlayer?.theEvent === "null"
                                    ? ""
                                    : activePlayer?.theEvent}
                            </div>
                            <div className="col-10 text-end pe-2" id="view_eventdy">
                                {activePlayer?.eventDy || activePlayer?.nflDy || ""}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
